<template>
    <div class="view-data-wrapper">
        <div style="margin: 15px 0;">
            <el-row :gutter="30">
                <el-col :sm="24" :md="12">
                    <!-- <el-select v-model="viewDataCode" style="width:100%;margin:10px auto;" filterable clearable placeholder="产品简码" @change="simpleCodeChange">
                      <template v-for="(ser,index) in simpleCodeGroup">
                        <el-option :label="ser.label" :value="ser.value" :key="index"></el-option>
                      </template>
                    </el-select> -->
                    <el-input placeholder="输入简码，多简码以逗号分隔" v-model="filterSimpleCodes" clearable class="input-with-select" @input="onSimpleCodesSearch" style="width:100%;margin:10px auto;">
                        <el-button slot="append" icon="el-icon-search" @click="onSimpleCodesSearch"></el-button>
                    </el-input>
                </el-col>
                <el-col :sm="24" :md="12">
                    <el-date-picker
                        style="width:100%;margin:10px auto;"
                        v-model="viewDataDate"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-col>
                <el-col :sm="24" :md="24">
                    <el-input placeholder="选择类型并搜索" v-model="viewDataSearch" clearable class="input-with-select" style="width:100%;margin:10px auto;">
                        <el-select v-model="select" slot="prepend" placeholder="请选择搜索类型" style="width:130px">
                            <el-option
                                v-for="(item,key) in searchOptions"
                                :key="key"
                                :label="item.label" 
                                :value="item.value"></el-option>
                        </el-select>
                        <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
                    </el-input>
                </el-col>
            </el-row>
            
        </div>
        <div class="section-heade-title">
            <el-row :gutter="10">
                <el-col :span="12"><span class="title-name">项目名称</span></el-col>
                <el-col :span="3" style="text-align:center"><span class="title-name">项目状态</span></el-col>
                <el-col :span="5" style="text-align:center"><span class="title-name">项目编号</span></el-col>
                <el-col :span="4" style="text-align:center"><span class="title-name"> 报备时间</span></el-col>
            </el-row>
        </div>
        <div class="card-container">
            <div class="card-item" v-for="(item,key) in viewData" :key="key">
                <div class="card-head" :class="item.isShow?'active':''"> 
                    <el-row :gutter="10" >
                        <el-col :span="12">
                            <span class="head-name">{{item.projectName}}</span>
                        </el-col>
                        <el-col :span="3" style="text-align:center">
                            <span class="head-name" style="text-align:center">{{item.projectStatus}}</span>
                        </el-col>
                        <el-col :span="5" style="text-align:center">
                            <span class="head-name" v-if="!item.linkable" style="text-align:center">{{item.id}}</span>
                            <span class="click-color" v-if="item.linkable" style="text-align:center" @click="showProjectDetail(item)">{{item.id}}</span>
                        </el-col>
                        <el-col :span="4" style="text-align:center"><span class="head-name">{{item.applyTimestamp | date}}</span></el-col>
                    </el-row>
                    <el-row :gutter="10" >
                        <el-col :span="24">
                            <span class="head-name" style="text-align:left;">项目地址：{{item.country}} - {{item.province}} - {{item.city}} - {{item.street}}</span>
                        </el-col>
                    </el-row>
                </div>
                <div class="card-body" v-if="item.isShow">
                    <el-form label-width="100px" class="demo-ruleForm">
                        <el-row :gutter="10" v-for="(project,key) in item.items" :key="key">
                            <el-col :span="6">
                                <div class="card-product-item">
                                    <span class="card-title">产品简码:</span>
                                    <span class="card-name">{{project.simpleCode}}</span>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="card-product-item">
                                    <span class="card-title">产品规格:</span>
                                    <span class="card-name">{{project.specification}}</span>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="card-product-item">
                                    <span class="card-title">平方数:</span>
                                    <span class="card-name">{{project.squareMeters}} m<sup>2</sup></span>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="card-product-item">
                                    <span class="card-title">保护价格:</span>
                                    <span class="card-name">{{project.quotedPrice}}</span>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <div class="show-product" @click="showProject(item)">
                    <!-- <span v-if="item.isShow === false">点击查看更多</span>
                    <span v-else>点击收起</span> -->
                    <span class="icon">
                        <i class="el-icon-arrow-up" v-if="item.isShow === false"></i>
                        <i class="el-icon-arrow-down" v-else></i>
                    </span>
                </div>
            </div>
        </div>
        <el-pagination
            class="view-data-pagenation"
            layout="prev, pager, next"
            :page-size="size"
            :total="total"
            @current-change="currentPage">
        </el-pagination>
    </div>
</template>
<script>
import qs from 'qs'
import { throttle, debounce } from '@/utils/app'
export default {
    name: 'quickView',
    props:{
        value:{
            type: String,
            default: ''
        }
    },
    data(){
        return {
            viewDataSearch: this.value,
            viewDataDate: null,
            viewDataCode:'',
            simpleCodeGroup:[],
            viewData:[],
            size: 10,
            page: 0,
            total: 0,
            filterParam:{
                projectName: this.value,
                country:'',
                province:'',
                city:'',
                street:''
            },
            filterSimpleCodes: '',
            select:'projectName',
            searchOptions:[
                {
                    label:'项目名称',
                    value:'projectName'
                },
                {
                    label:'国家',
                    value:'country'
                },
                {
                    label:'省份',
                    value:'province'
                },
                {
                    label:'城市',
                    value:'city'
                },
                {
                    label:'详细地址',
                    value:'street'
                },
            ]
        }
    },
    created(){
        this.fetchViewData()
        this.getFilterOptionsOfCode()
    },
    watch:{
        viewDataSearch(val){
            throttle(()=>{
                this.onSearch()
            })();
        },
        value(val){
            this.viewDataSearch = val
            this.filterParam.projectName = val
        },
        viewDataDate(val){
            this.page = 0
            this.fetchViewData()
        }
    },
    methods:{
        filterOptionParams(){
            return{
                page: this.page,
                size: this.size,
                "items.simpleCode": this.viewDataCode,
                simpleCodes: this.filterSimpleCodes,
                projectName: this.filterParam.projectName,
                country: this.filterParam.country,
                province: this.filterParam.province,
                city: this.filterParam.city,
                street: this.filterParam.street
            }
        },
        fetchViewData(){
            let startDate = this.viewDataDate !== null ? new Date(this.viewDataDate[0]).toISOString() : ''
            let endDate = this.viewDataDate !== null ? new Date(this.viewDataDate[1]).toISOString() : ''
            this.$api.get(`/projects/quick_view?applyTimestamp=${startDate}&applyTimestamp=${endDate}&${qs.stringify(this.filterOptionParams())}`).then(res => {
                if(res.status === 200 || res.status === 206){
                    if(res.data.content.length > 0){
                        res.data.content.forEach(ele => {
                            ele.isShow = false
                        })
                    }   
                    this.viewData = res.data.content
                    this.total = res.data.totalElements
                }
            }).catch(err => {
                console.error('获取预览数据失败',err.response)
            })
        },
        getFilterOptionsOfCode(){
            this.$api.get(`/inventories/filter`).then(res=>{
                if(res.status === 200 || res.status === 206){
                    res.data.simpleCodes.forEach(element => {
                        this.simpleCodeGroup.push({
                            label: element,
                            value: element
                        })
                    });
                }
            }).catch(err => {
                console.error(err.response)
                this.$message.error(err.response.data.message)
            })
        },
        currentPage(val){
            this.page = (val-1)
            this.fetchViewData()
        },
        onSearch(){
            for(let key in this.filterParam){
                if(key === this.select){
                    this.filterParam[key] = this.viewDataSearch
                }else{
                    this.filterParam[key] = ''
                }
            }
            this.page = 0
            this.viewData = []
            this.fetchViewData()
        },
        simpleCodeChange(val){
            this.page = 0
            this.viewData = []
            this.fetchViewData()
        },
        onSimpleCodesSearch(){
            debounce(() => {
                this.page = 0
                this.viewData = []
                this.fetchViewData()
            },600)()
        },
        onAddressSearch(){
            this.page = 0
            this.viewData = []
            this.fetchViewData()
        },
        showProject(item){
            item.isShow = !item.isShow
        },
        showProjectDetail(item){
            this.$emit('closeDrawer',false)
            this.$router.push({
                path:'/report/show',
                query:{
                    model:'show',
                    id:item.id
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
    .view-data-wrapper{
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        text-align: center;
    }
    .view-table{
        padding: 0 10px 0 0;
    }
    .view-data-pagenation{
        margin: 15px 0;
    }
    .section-heade-title{
        box-sizing: border-box;
        padding: 0 15px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        text-align: left;
        color: #aca7a7;
        border-bottom: 2px solid #e0dddd; 
        margin-bottom: 15px;
    }
    .card-item{
        box-sizing: border-box;
        margin-bottom: 30px;
        font-size: 0;
        color: #747171;
        text-align: left;
        overflow: hidden;
        .card-head{
            box-sizing: border-box;
            min-height: 60px;
            line-height: 26px;
            text-align: left;
            padding: 5px 15px;
            color: #747171;
            border: 1px solid #ddd;
            border-left: 1px solid #ddd;
            border-right: 1px solid #ddd;
            cursor: pointer;
            span{
                display: inline-block;
                font-size: 14px;
            }
            .icon{
                width: 25px;
                text-align: left;
                cursor: pointer;
            }
            .click-color{
                color: #1c99ff;
            }
            .head-name{
                
            }
            &.active{
                background-color: #ffe21c;
                color: #333;
                border: 1px solid #ffe21c;
            }
        }
        .card-body{
            border: 1px solid #ddd;
            box-sizing: border-box;
            padding: 0 10px;
            border-bottom: 1px solid #ddd;
            .card-product-item{
                width: 100%;
                font-size: 14px;
                color: #333;
                text-align: left;
                line-height: 20px;
                margin: 10px auto;
                .card-title{
                    text-align: left;
                    padding-right: 5px;
                }
            }
        }
        .show-product{
            box-sizing: border-box;
            width: 100%;
            height: 30px;
            line-height: 30px;
            text-align: center;
            font-size: 14px;
            color: #6d6d6b;
            cursor: pointer;
            border: 1px solid #ddd;
            border-top: 1px solid transparent;
            overflow: hidden;
        }
    }
</style>